export const httpStatusCodeResponses: any = {
  "0"  : "Unknown error",
  "400": "Bad request",
  "404": "Entity not found",
  "405": "Method not allowed",
  "409": "Data conflict",
  "500": "Oops Something went wrong, please try again later or contact with support team",
  "504": "Server is temporarily unavailable, please try again later"
};
